const ROUTES = {
  GET_USERS: '/admin/users.json',
  SIGN_OUT: '/users/sign_out.json'
}

export default ROUTES;